import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, ElementRef, ViewChild  } from '@angular/core';
import { ReportService } from './report.service';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { AppService } from '../../app.service';
import { Globals } from '../../globals';
import { ReportValidator } from './report.component.formvalidator';
import { ValidationModalComponent } from '../../shared/views/ValidationModalComponent/validation.modal.component';
import translateJson from '../../../translate.json';
import customerJson from '../../../assets/config/customer.json';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { AuthenticationService } from '../../auth';

@Component({
    selector: 'report-comp',
    providers: [ReportService, ConfirmService, AppService, ReportValidator, AuthenticationService],
    templateUrl: './report.component.html',  
    styleUrls: ['./report.component.css']  
})

export class ReportComponent {   

    @ViewChild('validationModal') validationModal: ValidationModalComponent;

    // Get translation/text from customerJson
    private i18 = translateJson.i18;
    private customerSettings = customerJson.settings;
    private activeComponent: boolean;
    showLoader: Boolean = false;

    /* Params */
    readyForCheckbox: boolean = false;
    readyForButton: boolean = false; 
    readyForParamOne: boolean = false;
    readyForParamTwo: boolean = false;
    readyForParamThree: boolean = false;
    readyForParamFour: boolean = false;
    readyForParamFive: boolean = false;
    readyForParamSix: boolean = false;
    readyForParamSeven: boolean = false;
    readyForParamEight: boolean = false;
    readyToSendCheckbox: boolean = false;
    requiredField : boolean = false;
    checkBoxParams: any = [];
    checkBoxParamToSend: any = [];
    chosenParameter: any = {};
    chosenReport: any = {};
    avaliableParameters: any;
    valuesToValidate: any = [];
    exportFormat: any;
    generatedReports: Array<Object> = [{name: String, id: String}];
    
    /* Forms */

    reportForm: FormGroup

    constructor(
        private service: ReportService,          
        private confirmService: ConfirmService,
        private validator: ReportValidator,
        private appService: AppService,
        private ngxSmartModalService: NgxSmartModalService,
        private globals: Globals,
        private authService: AuthenticationService) {
            this.authService.isAuthenticated();
            this.activeComponent = appService.isComponentActive('oldreport');
            this.setDefault();
        }

    setDefault() {

        this.exportFormat = this.service.getDefaultExportFormat();

        this.reportForm = new FormGroup({
            rcInput: new FormControl({disabled: false}),  
            rcOptionsCheckboxValues: new FormControl({disabled: false, active: false}),
            rcParams: new FormControl(),
            rcParamsOne: new FormControl(),
            rcParamsTwo: new FormControl(),
            rcParamsThree: new FormControl(),
            rcParamsFour: new FormControl(),
            rcParamsFive: new FormControl(),
            rcParamsSix: new FormControl(),
            rcParamsSeven: new FormControl(),
            rcParamsEight: new FormControl()
        });

        if(this.globals.userrole === 'ROLE_USERS' || this.globals.userrole === 'ROLE_ADMINS') {
            this.service.getReports()
                .subscribe(
                    data => this.setAvaliableParameters(data),
                    error => this.showError(error.error),
                    () => this.showLoader = false
                );
        }

        this.chosenParameter.inputType = null;
    }

    /**
     * Change export format and store in a cookie
     * and the changes will remain unitl user changes again
     * @param format 
     */
    setExportFormat(format) {
        this.exportFormat = this.service.setDefaultExportFormat(format);
    }

    setAvaliableParameters(parameterList) {
        this.avaliableParameters = parameterList;
    }

    setCheckboxParameters(parameterList) {
        this.checkBoxParams = parameterList
    }

    showError(error) {
        this.showLoader = false;
        if(error === 'OK'){
            this.confirmService.error(this.i18.report.form.genericReportError);
        } else {
            this.confirmService.error(this.appService.getTranslatedErrorMessage(error));
        }
    }

    clearForms(doClear: boolean) {
        if(doClear) {
            this.reportForm.get('rcParamsOne').reset();
            this.reportForm.get('rcParamsTwo').reset();
            this.reportForm.get('rcParamsThree').reset();
            this.reportForm.get('rcParamsFour').reset();
            this.reportForm.get('rcParamsFive').reset();
            this.reportForm.get('rcParamsSix').reset();
            this.reportForm.get('rcParamsSeven').reset();
            this.reportForm.get('rcParamsEight').reset();

            this.readyForParamOne = false;
            this.readyForParamTwo = false;
            this.readyForParamThree = false;
            this.readyForParamFour = false;
            this.readyForParamFive = false;
            this.readyForParamSix = false;
            this.readyForParamSeven = false;
            this.readyForParamEight = false;
            this.checkBoxParamToSend = [];
            this.checkBoxParams = [];
            this.readyForCheckbox = false;
            this.readyForButton = false;
            this.readyToSendCheckbox = false;
            this.requiredField = false;
        }
    }

    /*
    Set's the corresponding report data upon selection
    */
    setChosenReport(report) {
        this.clearForms(true);
        // if no report is selected (Choose report option)
        if(report === 'null') {
            return;
        }
        if(report === 'default') {
            // We fall through if we select the default text, wont spawn any more dialogs
            return;
        }
        for(let forReport of this.avaliableParameters){
            if(forReport.reportName === report){
                this.chosenParameter = Object.assign({}, forReport);
                this.readyForParamOne = true;
                this.setCheckboxParameters(forReport.spDataValues);
            }
        }
        if(this.chosenParameter.reportParam[0].reportParamValue === 1){
            setTimeout( () => {
                this.setChosenParameter(this.chosenParameter.reportParam[0].reportParamValue.paramName, 0);
            }, 1);
        } else {
        }


        if(this.chosenParameter.reportParam.length === 2){
            this.chosenParameter.chosenOperator = null
            this.readyForParamTwo = true;
        }
        if(this.chosenParameter.reportParam.length === 3){
            this.chosenParameter.chosenOperator = null
            this.readyForParamTwo = true;
            this.readyForParamThree = true;
        }
        if(this.chosenParameter.reportParam.length === 4){
            this.chosenParameter.chosenOperator = null
            this.readyForParamTwo = true;
            this.readyForParamThree = true;
            this.readyForParamFour = true;
        }
        if(this.chosenParameter.reportParam.length === 5){
            this.chosenParameter.chosenOperator = null
            this.readyForParamTwo = true;
            this.readyForParamThree = true;
            this.readyForParamFour = true;
            this.readyForParamFive = true;
        }
        if(this.chosenParameter.reportParam.length === 6) {
            this.chosenParameter.chosenOperator = null
            this.readyForParamTwo = true;
            this.readyForParamThree = true;
            this.readyForParamFour = true;
            this.readyForParamFive = true;
            this.readyForParamSix = true;
        }
        if(this.chosenParameter.reportParam.length === 7) {
            this.chosenParameter.chosenOperator = null
            this.readyForParamTwo = true;
            this.readyForParamThree = true;
            this.readyForParamFour = true;
            this.readyForParamFive = true;
            this.readyForParamSix = true;
            this.readyForParamSeven = true;
        }
        if(this.chosenParameter.reportParam.length === 8) {
            this.chosenParameter.chosenOperator = null
            this.readyForParamTwo = true;
            this.readyForParamThree = true;
            this.readyForParamFour = true;
            this.readyForParamFive = true;
            this.readyForParamSix = true;
            this.readyForParamSeven = true;
            this.readyForParamEight = true;
        }
        this.readyForCheckbox = true;
        this.readyForButton = true;
        if(!this.chosenParameter.storedProcedure.includes('OpenFields')) {
            this.requiredField = true;
        }
    }

    /*
    Called when an options in the in param's fields (dropdowns, textboxes) are set    
    */
    setChosenParameter(param, index) {
        if(this.chosenParameter.storedProcedure.includes('OpenFields')){
            this.reportForm.get('rcOptionsCheckboxValues').enable();
        }
        else if(this.chosenParameter.storedProcedure.includes('sp_getActiveGovRKPersons')) {
            this.reportForm.get('rcOptionsCheckboxValues').enable();
        }
        else if(index === (this.chosenParameter.reportParam.length - 1)){
            this.reportForm.get('rcOptionsCheckboxValues').enable();
        }
        this.readyToSendCheckbox = true
    }

    /*
    Add/remove checkbox to/from array to be sent with the report
    */
    setChosenCheckbox(internalName, displayName, value){
        let controlStr = internalName + ',' + displayName
        if(value) {
            this.checkBoxParamToSend.push({"param": internalName + ','+ displayName},)
        } else {
            for (let i = 0; i < this.checkBoxParamToSend.length; i++){
                if(this.checkBoxParamToSend[i].param === controlStr){
                    this.checkBoxParamToSend.splice(i, 1)
                }
            }
        }
        this.readyToSendCheckbox = true
    }

    clearFields(){
        this.confirmService.confirm(this.i18.report.form.confirmClearFields)
            .then(result => {
                if (result) {
                    this.readyForCheckbox = false;
                    this.readyForButton = false; 
                    this.readyForParamOne = false;
                    this.readyForParamTwo = false;
                    this.readyForParamThree = false;
                    this.readyForParamFour = false;
                    this.readyForParamFive = false;
                    this.readyForParamSix = false
                    this.readyForParamSeven = false
                    this.readyForParamEight = false
                    this.readyToSendCheckbox = false;
                    this.checkBoxParamToSend = [];
                    this.checkBoxParams = [];
                    this.chosenParameter = {};
                    this.reportForm.reset();
                    this.chosenParameter.inputType = null;
                    this.valuesToValidate = [];
                    this.reportForm.controls['rcInput'].patchValue('null');
                } else {
                    return;
                }});
    }

    displayData(data){
        
    }

    sendReport() {
        this.valuesToValidate = [];       
        let paramArray = [];
        for(let i = 0; i< this.chosenParameter.reportParam.length; i++){
            for(let forReport of this.chosenParameter.reportParam[i].reportParamValue){             
                if (i === 0 && forReport.paramName === this.reportForm.get('rcParamsOne').value){
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        this.chosenParameter.reportParam[i].paramName + ',paramValue='+ forReport.paramValue},)
                    this.valuesToValidate.push(forReport.paramValue);
                } 
                else if (i === 0 && this.chosenParameter.reportParam[i].inputType === 'text') {
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        forReport.paramName + ',paramValue='+ this.reportForm.get('rcParamsOne').value},)
                    this.valuesToValidate.push(this.reportForm.get('rcParamsOne').value);
                } 
                else if (i === 1 && forReport.paramName === this.reportForm.get('rcParamsTwo').value){
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        this.chosenParameter.reportParam[i].paramName + ',paramValue='+ forReport.paramValue},)
                    this.valuesToValidate.push(forReport.paramValue);
                } 
                else if (i === 1 && this.chosenParameter.reportParam[i].inputType === 'text') {
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        forReport.paramName + ',paramValue='+ this.reportForm.get('rcParamsTwo').value},)
                    this.valuesToValidate.push(this.reportForm.get('rcParamsTwo').value);
                } 
                else if (i === 2 && forReport.paramName === this.reportForm.get('rcParamsThree').value){
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        this.chosenParameter.reportParam[i].paramName + ',paramValue='+ forReport.paramValue},)
                    this.valuesToValidate.push(forReport.paramValue);
                } 
                else if (i === 2 && this.chosenParameter.reportParam[i].inputType === 'text') {
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        forReport.paramName + ',paramValue='+ this.reportForm.get('rcParamsThree').value},)
                    this.valuesToValidate.push(this.reportForm.get('rcParamsThree').value);
                } 
                else if (i === 3 && forReport.paramName === this.reportForm.get('rcParamsFour').value){
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        this.chosenParameter.reportParam[i].paramName + ',paramValue='+ forReport.paramValue},)
                    this.valuesToValidate.push(forReport.paramValue);
                } 
                else if (i === 3 && this.chosenParameter.reportParam[i].inputType === 'text') {
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        forReport.paramName + ',paramValue='+ this.reportForm.get('rcParamsFour').value},)
                    this.valuesToValidate.push(this.reportForm.get('rcParamsFour').value);
                } 
                else if (i === 4 && forReport.paramName === this.reportForm.get('rcParamsFive').value){
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        this.chosenParameter.reportParam[i].paramName + ',paramValue='+ forReport.paramValue},)
                    this.valuesToValidate.push(forReport.paramValue);
                } 
                else if (i === 4 && this.chosenParameter.reportParam[i].inputType === 'text') {
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        forReport.paramName + ',paramValue='+ this.reportForm.get('rcParamsFive').value},)
                    this.valuesToValidate.push(this.reportForm.get('rcParamsFive').value);
                }
                else if (i === 5 && forReport.paramName === this.reportForm.get('rcParamsSix').value){
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        this.chosenParameter.reportParam[i].paramName + ',paramValue='+ forReport.paramValue},)
                    this.valuesToValidate.push(forReport.paramValue);                    
                } 
                else if (i === 5 && this.chosenParameter.reportParam[i].inputType === 'text') {
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        forReport.paramName + ',paramValue='+ this.reportForm.get('rcParamsSix').value},)
                    this.valuesToValidate.push(this.reportForm.get('rcParamsSix').value);
                }
                else if (i === 6 && forReport.paramName === this.reportForm.get('rcParamsSeven').value){
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        this.chosenParameter.reportParam[i].paramName + ',paramValue='+ forReport.paramValue},)
                    this.valuesToValidate.push(forReport.paramValue);                    
                } 
                else if (i === 6 && this.chosenParameter.reportParam[i].inputType === 'text') {
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        forReport.paramName + ',paramValue='+ this.reportForm.get('rcParamsSeven').value},)
                    this.valuesToValidate.push(this.reportForm.get('rcParamsSeven').value);
                }
                else if (i === 7 && forReport.paramName === this.reportForm.get('rcParamsEight').value){
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        this.chosenParameter.reportParam[i].paramName + ',paramValue='+ forReport.paramValue},)
                    this.valuesToValidate.push(forReport.paramValue);                    
                } 
                else if (i === 7 && this.chosenParameter.reportParam[i].inputType === 'text') {
                    paramArray.push({"param": 'paramType=' + forReport.paramType + ',paramName='+ 
                        forReport.paramName + ',paramValue='+ this.reportForm.get('rcParamsEight').value},)
                    this.valuesToValidate.push(this.reportForm.get('rcParamsEight').value);
                }
            }
        }
        let jsonToSends = {
            "report_name": this.chosenParameter.reportName,
            "export_format": this.exportFormat,
            "storedProcedure": this.chosenParameter.storedProcedure,
            params: paramArray,
            options: this.checkBoxParamToSend
        }
        
        // if not all parms are requred set the remaining ones to empty string. and push unset dropdowns if they exists
        if(this.chosenParameter.storedProcedure.includes('OpenFields')){
            if (this.chosenParameter.storedProcedure.includes('OpenFields') && paramArray.length < (this.chosenParameter.reportParam.length)) {
                this.chosenParameter.reportParam.forEach(param => {
                    if(param.inputType === 'dropdown' && !this.findParamInArray(paramArray, param.paramName)){
                        let arrayIndex = this.chosenParameter.reportParam.findIndex(paramIndex => paramIndex === param)

                        let missingDropdown = {"param": 'paramType=' + param.paramType+ ',paramName='+ param.paramName + ',paramValue='}
                        paramArray.splice(arrayIndex, 0, missingDropdown);
                        this.valuesToValidate.push('');
                    }
                });
            }
            jsonToSends = this.setNullValuesToEmptyString(jsonToSends)
        }

        /* For existing customer reports */
        if (this.chosenParameter.storedProcedure.includes('sp_getActiveGovRKPersons')) {
            if (this.chosenParameter.storedProcedure.includes('sp_getActiveGovRKPersons') && paramArray.length === 7) {
                paramArray.push({"param": 'paramType=' + 'varchar'+ ',paramName='+
                    'Säkerhetsklass' + ',paramValue='},)
                    this.valuesToValidate.push('');
            }
            jsonToSends = this.setNullValuesToEmptyString(jsonToSends)
        }

        this.showLoader = true;
        /*this.service.validateReport(jsonToSends).subscribe(
            data => this.generateReport(jsonToSends),
            error => this.showError(error)
        );*/
        this.generateReport(jsonToSends);
    }

    generateReport(report){
        this.service.postReport(report)
            .subscribe(
                data => this.showDownloadModal(data),
                async error => {
                    this.showError(error);
                    },
                () => this.showLoader = false
        );

    }
    /**
     * helper used with OpenFields reports to find if a dropdown param has been set
     * @param paramArray array of set params
     * @param paramToFind the param to look for
     * @returns boolean
     */
    findParamInArray(paramArray, paramToFind){
        let returnBool = false;
        paramArray.forEach(paramObj => {
            if(paramObj.param.includes(paramToFind)){
                returnBool = true
            }
        });
        return returnBool;
    }

    startFileDownload(data, fileName) {
        if(this.customerSettings.clearReportForm){
            this.reportForm.controls['rcInput'].patchValue('null');
        }
        this.clearForms(this.customerSettings.clearReportForm);
        if(window.navigator.msSaveOrOpenBlob) {           
          window.navigator.msSaveBlob(data, fileName + this.getDownloadFileType());
        } else {            
          const url = window.URL.createObjectURL(data);
          const anchor = document.createElement("a");
          anchor.href = url;         
          anchor.download = fileName + this.getDownloadFileType();
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);         
        }
    } 

    /**
     * Set file ending for supported export files
     */
    getDownloadFileType() {       
        switch(this.exportFormat) {
            case 'Excel':
                return '.xlsx';
            default:
                return '.pdf';
        }
    }

    /**
     * Used for the report sp_getActiveGovRKPersons to set unused input field values from null to
     * empty string.
     * @param jsonToSends 
     */
    setNullValuesToEmptyString(jsonToSends) {
        for (let param of jsonToSends.params) {
            param.param = param.param.replace('null', '');
        }
        return jsonToSends;
    }

    showDownloadModal(reportData) {
        let modalData: any = [];
        if(reportData != null && reportData.length > 0) {
            this.generatedReports = reportData;
            modalData[0] = reportData[0].type;
            modalData[1] = this.generatedReports.length
        }
        this.ngxSmartModalService.setModalData(modalData, 'reportDownloadModal', true);
        this.ngxSmartModalService.getModal('reportDownloadModal').open();
    }

    downloadReport(uuid, fileName, suffix){
        this.service.getReportStream(uuid, suffix)
        .subscribe(
            data => this.startFileDownload(data, fileName),
            error => this.showError(error)
        );
    }
    
    /**
     * Set route on click
     * @param routerLink route name
     * @param active if the route is active
     */
    setRoute(route) {
        this.appService.setRoute(route);
    }

}